'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.body = body;
/* istanbul ignore next */
function body() {
    return typeof document !== 'undefined' && document.body ? document.body : {};
}
//# sourceMappingURL=document.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/facades/document.js
// module id = 180
// module chunks = 0